import {OrderedSet} from 'immutable';


export default function reducer(state, action) {
    if (!state.get('questions'))
        state = state.set('questions', new OrderedSet());
    if (state.get('elementId') === action.elementId) {
        switch (action.type) {
        }
    }
    return state;
}
